import { Alert, Snackbar } from "@mui/material";
import useToast from "../../../../hooks/context/useToast";

export function Toast() {
  const { open, setOpen, toastData } = useToast();
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={toastData.duration}
      onClose={handleClose}
      anchorOrigin={toastData.anchor}
    >
      <Alert
        onClose={handleClose}
        severity={toastData.type}
        sx={{ width: "100%" }}
      >
        {toastData.message}
      </Alert>
    </Snackbar>
  );
}
